import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

class HandoffMessageRecord extends BaseMessageRecord({
  type: "handoff",
  handoffEmail: ""
}) {
  static getInvalidFields = () => Immutable.List()
}

export default HandoffMessageRecord;
